import React from 'react';

/**
 * Icône hamburger (menu)
 */
const MenuIcon = () => (
  <svg
    className="hamburger-icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="3" y1="12" x2="21" y2="12" />
    <line x1="3" y1="6" x2="21" y2="6" />
    <line x1="3" y1="18" x2="21" y2="18" />
  </svg>
);

/**
 * Header mobile avec bouton hamburger
 * Affiché uniquement sur les petits écrans
 */
const MobileHeader = ({ onMenuOpen }) => {
  return (
    <header className="mobile-header">
      <div className="mobile-header-left">
        <button
          className="hamburger-btn"
          onClick={onMenuOpen}
          aria-label="Ouvrir le menu"
          aria-expanded="false"
        >
          <MenuIcon />
        </button>
        <img
          src="/logo_connect_transparant.png"
          alt="R-Connect"
          className="mobile-logo"
        />
        <span className="mobile-logo-text">Renfort Connect</span>
      </div>
    </header>
  );
};

export default React.memo(MobileHeader);
